import { Injectable, effect, inject } from '@angular/core';

import { DomainProfileService } from '../domain-profile-services/domain-profile.service';
import { HeaderStorageService } from 'src/app/features/shared/storage/services/storage-services/header-storage-service';
import { headerData } from 'src/app/features/shared/header/models/header-data';

// Browsertab-titel: pagina-titel (headerData.title, de grote H1 in de header, wisselt per
// pagina) + domeinnaam (DomainProfileService.title$$, dezelfde bron als het label naast het
// logo — heeft al een robuuste fallback-keten tot aan de app-naam, zie profileData$$). Zelfde
// patroon als FaviconService: bij niets beschikbaars de bestaande titel laten staan i.p.v.
// leegmaken (voorkomt een lege tab-titel vóórdat de eerste pagina-/domeindata geladen is).
@Injectable({
    providedIn: 'root',
})
export class TitleService {
    private readonly __headerStorageService = inject(HeaderStorageService);
    private readonly __domainProfileService = inject(DomainProfileService);

    constructor() {
        effect(() => {
            const __pageTitle = this.__headerStorageService.headerData$$()?.[headerData.title] ?? null;
            const __domainName = this.__domainProfileService.title$$();
            const __title = [__pageTitle, __domainName].filter(Boolean).join(' — ');
            if (__title) document.title = __title;
        });
    }
}
